export default __webpack_public_path__ + "static/media/other-accommodation.72e87772.svg";